module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Regular.c82746c.otf";